export default __webpack_public_path__ + "static/media/support.88b69cd3.svg";